import { green } from '@/shared/styles/colors';
import styled from '@emotion/native';
import { uuid4 } from '@sentry/core';
import React from 'react';
import { useWindowDimensions } from 'react-native';

interface BorderProps {
  color?: string;
  dashGap?: number;
  dashWidth?: number;
}

const DashedBorder: React.FC<BorderProps> = ({
  color = green,
  dashGap = 5,
  dashWidth = 10,
}) => {
  const { width } = useWindowDimensions();
  const uuid = uuid4();
  // Calculate number of dashes that can fit in the screen width
  const totalWidth = dashWidth + dashGap;
  const numberOfDashes = Math.floor(width / totalWidth);

  // Create array of dash indices
  const dashes = Array.from({ length: numberOfDashes }, (_, i) => i);

  return (
    <Container>
      {dashes.map((index) => (
        <Dash
          key={uuid + index}
          width={dashWidth}
          backgroundColor={color}
          marginRight={index === numberOfDashes - 1 ? 0 : dashGap}
        />
      ))}
    </Container>
  );
};

const Container = styled.View({
  flexDirection: 'row',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
});

const Dash = styled.View(
  ({
    width,
    backgroundColor,
    marginRight,
  }: {
    width: number;
    backgroundColor: string;
    marginRight: number;
  }) => ({
    height: 1,
    width,
    backgroundColor,
    marginRight,
  }),
);

export default DashedBorder;
